import React from 'react'
import './ICSTagBox.css'
import { Label, FormFeedback } from 'reactstrap'
import { Controller, Control, FieldValues, FieldErrors } from 'react-hook-form'
import TagBox from 'devextreme-react/tag-box'
import ICSToolTip from '../ICSToolTip/ICSToolTip'

const ICSTagBox = ({
  name,
  id = `${name}Input`,
  control,
  errors,
  placeholder = 'Input text and hit enter to create a tag',
  label,
  dataList = [],
  defaultValue = [],
  helpText,
}: ICSTagBoxProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, value, name, ref },
        fieldState: { invalid, isTouched, isDirty, error },
      }) => {
        const onValueChanged = e => {
          onChange(e.value)
        }
        return (
          <>
            <Label for={id} className='input-label'>
              {label}
              {helpText && (
                <ICSToolTip
                  id={`${name}ToolTip`}
                  text={helpText}
                  target={`#${name}ToolTip`}
                />
              )}
            </Label>
            <TagBox
              id={id}
              items={dataList}
              className={
                !(isTouched || isDirty) ||
                (value === defaultValue && (isTouched || isDirty) && !invalid)
                  ? ''
                  : error === undefined &&
                    (isTouched || isDirty) &&
                    value !== defaultValue
                  ? 'custom-valid-tagbox'
                  : 'custom-invalid-tagbox'
              }
              acceptCustomValue={true}
              onValueChanged={onValueChanged}
              placeholder={placeholder}
              ref={ref}
              searchEnabled={true}
            />
            <FormFeedback
              valid={errors?.[name] ? false : true}
              role='alert'
              id={`${name}Error`}
            >
              {errors?.[name]?.message}
            </FormFeedback>
          </>
        )
      }}
    />
  )
}

export default ICSTagBox

type ICSTagBoxProps<TFieldValues extends FieldValues = FieldValues> = {
  id?: string
  name: string
  control: Control<TFieldValues>
  errors: FieldErrors<TFieldValues>
  placeholder?: string
  label: string
  dataList?: string[]
  defaultValue?: Record<string, unknown>[]
  helpText?: string
}
